import apiClient from "./apiClient";

// Create Survey
const createSurvey = async (surveyData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/CreateSurvey",
			surveyData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

// Get all surveys by user
const getAllSurveysByUser = async (userData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetAllSurveysByUser",
			userData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

//Get Survey Details
const GetSurveyDetails = async (surveyData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetSurveyDetails",
			surveyData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

//Add question for case study
const AddQuestion = async (questionData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/AddQuestion",
			questionData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetQuestionsByAssessmentID = async (questionData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetQuestionByAssessmentID",
			questionData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const DeleteQuestionCS = async (deleteData) => {
	try {
		const payload = {
			...deleteData,
			questionUID: deleteData.questionUID.toString(),
		};
		const response = await apiClient.post(
			"/api/Survey/DeleteQuestionCS",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const getUserDetailsCS = async () => {
	try {
		const token = localStorage.getItem("JWTToken");
		const userID = parseInt(localStorage.getItem("userID"), 10);

		if (!token || !userID) throw new Error("Missing token or userID");

		const payload = {
			token,
			userID,
		};

		const response = await apiClient.post(
			"/api/Survey/GetUserDetailsCS",
			payload
		);

		return response.data;
	} catch (error) {
		return error.response
			? error.response.data
			: { status: "Fail", message: error.message || "Something went wrong" };
	}
};

const UpdateSurveyCS = async (surveyData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/UpdateSurveyCS",
			surveyData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetSurveyDetailsByResponderUID = async (surveyData) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetSurveyDetailsByResponderUID",
			surveyData
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const PublishSurvey = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/PublishSurveyCS",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const RecordResponse = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/RecordResponse",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};
const GetQuestionsForResponder = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetSurveyQuestionsForResponder",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};
const GoToQuestionResponder = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GoToQuestionResponder",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};
const FinishSurvey = async (payload) => {
	try {
		const response = await apiClient.post("/api/Survey/FinishSurvey", payload);
		return response.data;
	} catch (error) {
		throw error;
	}
};

const createResponders = async (assessmentUID, excelFile) => {
	try {
		const formData = new FormData();
		formData.append("AssessmentUID", assessmentUID);
		formData.append("Excel", excelFile);

		const response = await apiClient.post(
			"/api/Survey/CreateResponders",
			formData,
			{
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}
		);

		return response.data;
	} catch (error) {
		console.error("Error uploading responders:", error);
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetSurveyResponders = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetSurveyResponders",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetSurveyData = async (payload) => {
	try {
		const response = await apiClient.post("/api/Survey/GetSurveyData", payload);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const ExportSurveyResponses = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Reports/GetCaseStudyAnswers",
			payload,
			{
				responseType: "blob",
			}
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const EditScheduledSurvey = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/EditScheduledSurvey",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const ActivateSurvey = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/ActivateSurvey",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const DeactivateSurvey = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/DeactivateSurvey",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const UpdateQuestionSeq = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/UpdateQuestionSeq",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetCaseStudy = async (caseStudyFile) => {
	try {
		const response = await apiClient.get(
			`/api/Survey/GetCaseStudy/${caseStudyFile}`,
			{ responseType: "arraybuffer" } // <-- important
		);
		return response.data; // will be ArrayBuffer
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Error fetching Case Study" };
	}
};

const ScheduleReminder = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/ScheduleReminder",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

const GetScheduledReminder = async (payload) => {
	try {
		const response = await apiClient.post(
			"/api/Survey/GetScheduledReminder",
			payload
		);
		return response.data;
	} catch (error) {
		throw error.response
			? error.response.data
			: { status: "Fail", message: "Something went wrong" };
	}
};

 const GetSurveyTimer = async (payload) => {
  try {
    const response = await apiClient.post(
      "/api/Survey/GetSurveyTimer",
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { status: "Fail", message: "Something went wrong" };
  }
};

const SaveCapturedTime = async (payload) => {
  try {
    const response = await apiClient.post(
      "/api/Survey/SaveCapturedTime",
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { status: "Fail", message: "Something went wrong" };
  }
};

export default {
	createSurvey,
	getAllSurveysByUser,
	GetSurveyDetails,
	AddQuestion,
	GetQuestionsByAssessmentID,
	DeleteQuestionCS,
	getUserDetailsCS,
	UpdateSurveyCS,
	GetSurveyDetailsByResponderUID,
	PublishSurvey,
	RecordResponse,
	FinishSurvey,
	createResponders,
	GetSurveyResponders,
	GetSurveyData,
	ExportSurveyResponses,
	EditScheduledSurvey,
	ActivateSurvey,
	DeactivateSurvey,
	UpdateQuestionSeq,
	GetCaseStudy,
	ScheduleReminder,
	GetScheduledReminder,
	GetQuestionsForResponder,
	GoToQuestionResponder,
	GetSurveyTimer,
	SaveCapturedTime
};
